<template>
  <footer class="footer">
    <router-link class="back-arrow" :to="`/${backLink}`">
      <span class="material-icons footer-title">
        keyboard_backspace
      </span>
    </router-link>

    <span v-if="hasItemsInCart" class="footer-title" @click="confirmOrder"
      >Confirmar pedido
    </span>
    <span> $ {{ this.getSelectedProducts }} </span>
    <div class="version">{{ getVersion }}</div>
  </footer>

  <!-- Footer -->
</template>
<script>
import { http } from "../axios";
import { baseUrl } from "../server";
import { version } from "../../package.json";
import cart_mixin from "../mixins/Cart_Mixin";
import footer_mixin from "../mixins/Footer_Mixin";

export default {
  mixins: [footer_mixin, cart_mixin],
  props: {
    backLink: {
      type: String,
      default: ""
    },
    confirmLink: {
      type: String,
      default: "/api/WAOrderConfirmed"
    },
    nextStep: {
      type: String,
      default: "/ConfirmOrder"
    }
  },
  computed: {
    getVersion() {
      return version;
    }
  },
  data() {
    return {};
  },
  methods: {
    processOrder() {
      let t = this;
      console.log(`Confirmando pedido en ${baseUrl}${this.confirmLink}`);
      this.$emit("onConfirmingOrder");
      let details = [];
      let totalAmount = 0.0;
      this.$store.getters.getSelectedProducts.forEach(item => {
        let subTotal = parseFloat(item.price) * item.quantity;
        details.push({
          Notes: null,
          Quantity: item.quantity,
          Product: {
            Code: item.sku,
            Name: item.name
          },
          OptionGroups: {},
          Subtotal: subTotal,
          Discount: 0.0
        });

        totalAmount += subTotal;
      });

      http
        .post(`${baseUrl}${this.confirmLink}`, {
          OrderCode: this.$store.getters.getOrderCode,
          User: {
            Name: this.$store.getters.getCustomerName,
            LastName: null,
            Email: null
          },
          Address: {
            Area: null,
            City: null,
            Description: this.$store.getters.getAddress,
            Phone: null
          },
          IsPickup: this.$store.getters.getIsPickup,
          Details: details,
          Payment: {
            Total: totalAmount,
            Tax: 0.0,
            Shipping: 0.0,
            PaymentAmount: totalAmount,
            Method: "Mercado Pago",
            Currency: "ARS"
          },
          Discounts: null,
          Notes: this.$store.getters.getNotes,
          Waiter: this.$store.getters.getWaiter,
          Table: this.$store.getters.getTable,
          ShopCode: this.$store.getters.getSelfServiceShopCode
        })
        .then(response => {
          if (response.data.responseCode === 0) {
            t.$store.commit(
              "SET_SELF_SERVICE_PAYMENT_LINK",
              response.data.paymentUrl
            );
            this.$emit("onOrderConfirmSuccess", response.data);
          } else {
            this.$emit("onOrderConfirmFailure", response.data.responseMessage);
          }
        })
        .catch(error => {
          console.log(error);
          alert("Error al cursar el pedido!");
        });
    },
    confirmOrder() {
      if (this.nextStep === "/ConfirmOrder") {
        this.processOrder();
      } else {
        this.$router.push(this.nextStep);
      }
    }
  },
  components: {}
};
</script>
<style scoped>
.footer-title {
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  color: black !important;
}
span {
  vertical-align: middle;
}
.back-arrow {
  float: left;
  top: 2px;
}
.version {
  float: right;
  font-size: 10px;
  text-decoration: none;
  color: grey !important;
}
.footer {
  padding-left: 20px;
  padding-right: 20px;
  position: fixed;
  bottom: 0;
  width: 100%;
  min-height: 4em;
  background-color: #f0f0f0;
  height: 100px;
  line-height: 100px;
  text-align: center;
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/Components/FooterCheckout.vue